import { gql } from "@apollo/client";
import { PROMO_DEDUCTION_MATCH_SUMMARY_FRAGMENT } from "./promoDeductionMatchSummary.fragment";
import { DEDUCTION_FRAGMENT } from "../deduction/deductionFragment";

export const PUT_PROMO_DEDUCTION_APPLIED = gql`
  ${PROMO_DEDUCTION_MATCH_SUMMARY_FRAGMENT}
  ${DEDUCTION_FRAGMENT}
  mutation PutPromoDeductionApplied($params: PutPromoDeductionAppliedInput!) {
    putPromoDeductionApplied(params: $params) {
      summaries {
        ...PromoDeductionMatchSummaryFields
      }
      deduction {
        ...DeductionFields
      }
    }
  }
`;
